// extracted by mini-css-extract-plugin
export var phone = "_1g-0";
export var phoneDragging = "_1g-1";